/* eslint-disable @typescript-eslint/ban-types */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Events {
    const store: Record<string, any> = {}
    let setListener: Function

    export function attach (event: string, callback: Function): void {
        if (!store[event]) {
            store[event] = []
        }
        store[event].push(callback)
    }

    export function fire (event: string, args: any[] = []): void {
        if (store[event]) {
            store[event].forEach((callback: any) => {
                callback(...args)
            })
        }
    }

    export function remove (event: string, callback?: Function): any {
        if (!callback) {
            delete store[event]
        }
        if (store[event]) {
            store[event] = store[event].filter((savedCallback: any) => {
                return callback !== savedCallback
            })
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    export function dom (element: any, event: string, callback: Function): any {
        if (!setListener) {
            if (element.addEventListener) {
                setListener = (el: any, ev: any, fn: any) => {
                    return el.addEventListener(ev, fn, false)
                }
            } else if (typeof element.attachEvent === 'function') {
                setListener = (el: any, ev: any, fn: any) => {
                    return el.attachEvent(`on${ev}`, fn, false)
                }
            } else {
                setListener = (el: any, ev: any, fn: any) => {
                    // eslint-disable-next-line no-return-assign, no-param-reassign
                    return el[`on${ev}`] = fn
                }
            }
        }
        return setListener(element, event, callback)
    }
}

// export default Events;
